import React from 'react';
import { 
  IconButton, 
  Badge,
  Tooltip
} from '@mui/material';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import { useBucket } from '../contexts/BucketContext';

interface BucketButtonProps {
  onClick?: () => void;
  className?: string;
  style?: React.CSSProperties;
}

const BucketButton: React.FC<BucketButtonProps> = ({ 
  onClick, 
  className,
  style 
}) => {
  const { savedAnswers, toggleDrawer } = useBucket();
  
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      toggleDrawer();
    }
  };

  return (
    <Tooltip title="Antworten-Sammlung">
      <IconButton 
        onClick={handleClick}
        color="primary"
        className={className}
        sx={{ 
          backgroundColor: 'white',
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
          '&:hover': {
            backgroundColor: '#f5f5f5'
          },
          ...style
        }}
      >
        <Badge badgeContent={savedAnswers.length} color="primary">
          <BookmarkIcon />
        </Badge>
      </IconButton>
    </Tooltip>
  );
};

export default BucketButton;
